import { render, staticRenderFns } from "./ApproveChallengeModal.vue?vue&type=template&id=040917cf&"
import script from "./ApproveChallengeModal.vue?vue&type=script&lang=js&"
export * from "./ApproveChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveChallengeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports